/**
 * useResolvedTenantHandle — the handle a tenant-branded component should render.
 *
 * Prefers an explicit prop, then the tenant context. Both layers are optional, and
 * that matters in two directions:
 *
 * - **No context:** the Storybook tuning stories render these components
 *   standalone, so `useTenant()` returning `null` must be a normal case, not a
 *   throw.
 * - **No handle at all:** returns `undefined`, and every consumer already treats
 *   that as "fall back to the Butter mark".
 *
 * The explicit prop deliberately wins so a story (or a preview surface rendering
 * another tenant's brand) can override whatever the surrounding app resolved.
 *
 * @module components/data-display/TenantLogo/useResolvedTenantHandle
 */

import { useTenant } from '#providers';

export function useResolvedTenantHandle(explicitHandle?: string): string | undefined {
  const tenant = useTenant();
  return explicitHandle ?? tenant?.handle ?? undefined;
}
